import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoCashbookFilter} from "./models/DtoCashbookFilter";
import {DtoCashbook} from "./models/DtoCashbook";

@Injectable()
export class CashbookService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'administration'
    }

    public getCashbook = (filter: DtoCashbookFilter): Observable<DtoCashbook[]> => {
        return this.http.post<DtoCashbook[]>(`${this.apiUrl}/cashbook`, filter);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/administration/cashbook/cashbook.service.ts